var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 50,
    viewBox: "0 0 261 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34.3724L4.89211 26.4907C9.64833 18.7448 19.2967 2.98138 28.945 0.399429C38.5933 -2.18252 48.3775 8.28116 58.0259 17.3859C67.6742 26.4907 77.3225 34.3724 86.9709 34.3724C96.6192 34.3724 106.268 26.4907 115.916 21.3268C125.564 16.027 135.348 13.4451 144.997 10.8631C154.645 8.28116 164.293 5.69922 173.942 2.98138C183.59 0.399429 193.238 -2.18252 202.887 2.98138C212.535 8.28116 222.319 21.3268 231.968 22.5498C241.616 23.9087 251.264 13.4451 256.02 8.28116L260.913 2.98138V50H256.02C251.264 50 241.616 50 231.968 50C222.319 50 212.535 50 202.887 50C193.238 50 183.59 50 173.942 50C164.293 50 154.645 50 144.997 50C135.348 50 125.564 50 115.916 50C106.268 50 96.6192 50 86.9709 50C77.3225 50 67.6742 50 58.0259 50C48.3775 50 38.5933 50 28.945 50C19.2967 50 9.64833 50 4.89211 50H0V34.3724Z",
    fill: "url(#paint0_linear_137_619)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_619",
    x1: 130.456,
    y1: 0,
    x2: 130.456,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A034FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A034FA",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph1);
export default __webpack_public_path__ + "static/media/graph1.66cbf4b4bbabe470641b6fe5820a0156.svg";
export { ForwardRef as ReactComponent };